import { render, staticRenderFns } from "./TraineeTableWidget.vue?vue&type=template&id=25a72d62"
import script from "./TraineeTableWidget.vue?vue&type=script&lang=js"
export * from "./TraineeTableWidget.vue?vue&type=script&lang=js"
import style0 from "./TraineeTableWidget.vue?vue&type=style&index=0&id=25a72d62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports